import { render, staticRenderFns } from "./TpmsListItemSingle.vue?vue&type=template&id=a4d2fe4e"
import script from "./TpmsListItemSingle.vue?vue&type=script&lang=js"
export * from "./TpmsListItemSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports